const titles = [
        {
            category: 9,
            itemNo: 0,
            itemName:'General Knowledge',
            difficulty:['Easy', 'Medium', 'Hard']
        },
        {
            itemNo:1,
            itemName:'Entertainment',
            subItems:[{
                category: 10,
                itemName: 'Books'
            },
            {
                category: 11,
                itemName: 'Movies'
            },
            {
                category: 12,
                itemName: 'Music'
            },
            {
                category: 14,
                itemName: 'Television'
            },
            {
                category: 32,
                itemName: 'Cartoons & Animation'
            },
            {
                category: 15,
                itemName: 'Video Games'
            }
        ],
            difficulty:['Easy', 'Medium', 'Hard']

        },
        {
            category: 9,
            itemNo: 2,
            itemName:'Science',
            subItems:[
                {
                    category: 19,
                    itemName: 'Maths'
                },
                {
                    category: 30,
                    itemName: 'Gadgets'
                },
                {
                    category: 18,
                    itemName: 'Computers'
                },
            ],
            difficulty:['Easy', 'Medium', 'Hard']
        },
        {
            category: 26,
            itemNo: 3,
            itemName:'Celebrities',
            difficulty:['Easy', 'Medium', 'Hard']
        },
        {
            category:27,
            itemNo: 4,
            itemName:'Animal',
            difficulty:['Easy', 'Medium', 'Hard']
        },
        {
            category:28,
            itemNo: 5,
            itemName:'Vehicle',
            difficulty:['Easy', 'Medium', 'Hard']
        }
    ];

export default titles;